import { Link } from 'react-router-dom';

interface CategoryItem {
  name: string;
  slug: string;
  icon: string;
  image: string;
}

const categoryItems: CategoryItem[] = [
  {
    name: '电影',
    slug: 'movie',
    icon: 'ri-film-line',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20movie%20theater%20screen%20with%20film%20projector%2C%20dark%20cinematic%20atmosphere%20with%20warm%20golden%20lighting%2C%20elegant%20velvet%20interior%2C%20empty%20cinema%20hall&width=400&height=240&seq=cat-movie&orientation=landscape',
  },
  {
    name: '电视剧',
    slug: 'tv-series',
    icon: 'ri-tv-line',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20modern%20living%20room%20with%20large%20TV%20screen%2C%20warm%20home%20atmosphere%20with%20soft%20lighting%2C%20comfortable%20sofa%2C%20night%20scene%2C%20entertainment%20theme&width=400&height=240&seq=cat-tv-series&orientation=landscape',
  },
  {
    name: '综艺',
    slug: 'variety',
    icon: 'ri-music-line',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20music%20stage%20with%20bright%20spotlights%2C%20concert%20atmosphere%2C%20vibrant%20show%20production%2C%20dynamic%20performance%20lighting%2C%20entertainment%20stage%20design&width=400&height=240&seq=cat-variety&orientation=landscape',
  },
  {
    name: '动漫',
    slug: 'anime',
    icon: 'ri-ghost-line',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20background%20with%20cherry%20blossoms%20and%20vibrant%20colors%2C%20artistic%20animation%20theme%2C%20Japanese%20anime%20aesthetic%2C%20dreamy%20atmosphere&width=400&height=240&seq=cat-anime&orientation=landscape',
  },
  {
    name: '纪录片',
    slug: 'documentary',
    icon: 'ri-earth-line',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20wildlife%20in%20natural%20habitat%2C%20BBC%20style%20cinematography%2C%20golden%20hour%20light%2C%20breathtaking%20landscape%2C%20professional%20nature%20photography&width=400&height=240&seq=cat-documentary&orientation=landscape',
  },
];

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-white">
      <div className="max-w-screen-2xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-serif">
              影视分类
            </h2>
            <p className="text-sm text-foreground-500 mt-1">按类型浏览你喜欢的影视内容</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categoryItems.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-xl overflow-hidden cursor-pointer"
            >
              <img
                src={cat.image}
                alt={`${cat.name} - 草民影院免费在线观看`}
                title={`${cat.name} - 草民影院免费${cat.name}在线观看`}
                className="w-full h-32 md:h-40 object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/20 backdrop-blur-sm">
                    <i className={`${cat.icon} text-white text-sm`}></i>
                  </div>
                  <span className="text-white font-bold text-base">{cat.name}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}